import React from "react";
import classNames from "classnames";
import styles from "./Content.module.scss";

const Content = ({ children, className = "" }) => {
    return (
        <div className={classNames(styles.body, className)} data-ui="content">
            {children}
        </div>
    );
};

export default Content;
